import { Box } from '@mui/material'
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { Control, useController, useFormContext } from 'react-hook-form'
interface ITimeFieldProps {
  name: string
  control: Control<any>
  label: string
  inputProps?: any
}

export function CustomTimeField({ name, control, label, ...inputProps }: ITimeFieldProps) {
  const [cleared, setCleared] = useState<boolean>(false)
  const {
    field: { value = null, onChange, ref },
    fieldState: { invalid, error }
  } = useController({
    name,
    control
  })
  const minTime = dayjs().hour(7).minute(0) // 7:00 AM
  const maxTime = dayjs().hour(22).minute(0) // 22:00 PM
  const { clearErrors, unregister, register, setError } = useFormContext()

  useEffect(() => {
    if (cleared) {
      clearErrors(name)
      unregister(name)
      register(name, { required: false })
      const timeout = setTimeout(() => {
        setCleared(false)
      }, 100)

      return () => clearTimeout(timeout)
    }
    return () => {}
  }, [cleared, clearErrors, unregister, register, name, invalid])

  return (
    <Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
          label={label}
          value={value ? dayjs(value) : null}
          ampm={false}
          thresholdToRenderTimeInASingleColumn={4}
          minTime={minTime}
          maxTime={maxTime}
          timeSteps={{ hours: 1, minutes: 1 }}
          onChange={onChange}
          inputRef={ref}
          {...inputProps}
          slotProps={{
            field: {
              clearable: true,
              onClear: () => {
                setCleared(true)
              }
            },
            textField: {
              error: invalid,
              helperText: error?.message,
              fullWidth: true,
              size: 'small',
              margin: 'normal'
            },
            actionBar: {
              actions: ['clear', 'cancel', 'accept']
              // onClear: () => {
              //   setCleared(true)
              // }
            }
          }}
        />
      </LocalizationProvider>
    </Box>
  )
}
